"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogLevel = exports.DUPLICATE_LOG_BUFFER_MILLISECONDS = exports.STRINGS_TO_WARN = void 0;
var katal_logger_1 = require("@amzn/katal-logger");
exports.STRINGS_TO_WARN = [
    // for older Firefox users: https://stackoverflow.com/questions/38174551/javascript-error-in-firefox-only-permission-denied-to-access-property-tojson
    "Permission denied to access property \"toJSON\" on cross-origin object",
    /**
     * Log errors that contain "chrome-extension" or the "querySelectorAll" error in the stack trace as warnings
     * Refs:
     * - https://t.corp.amazon.com/V888653610/communication
     * - https://t.corp.amazon.com/P91764674/communication
     */
    'chrome-extension',
    '198230182308109283091823098102938908128390'
];
/**
 * Log duplicate errors that occur in quick succession as warnings instead to decrease noise that can be caused by a single AA
 * Refs:
 *  - https://t.corp.amazon.com/V1016788425
 *  - https://t.corp.amazon.com/V1016090741
 *
 *  Increasing buffer
 *  - https://t.corp.amazon.com/V1045227649
 *  - https://t.corp.amazon.com/V1045127967
 */
exports.DUPLICATE_LOG_BUFFER_MILLISECONDS = 5000;
var getLogLevel = function (error, previousErrorTimestamp) {
    if (previousErrorTimestamp === void 0) { previousErrorTimestamp = undefined; }
    var stack = error.stack, message = error.message;
    var errorContainsWarningString = exports.STRINGS_TO_WARN.some(function (warnString) { return (stack === null || stack === void 0 ? void 0 : stack.includes(warnString)) || message === warnString; });
    var recentDuplicatedError = previousErrorTimestamp &&
        previousErrorTimestamp + exports.DUPLICATE_LOG_BUFFER_MILLISECONDS >=
            // eslint-disable-next-line no-restricted-globals
            Date.now();
    return errorContainsWarningString || recentDuplicatedError
        ? katal_logger_1.Level.WARN
        : katal_logger_1.Level.ERROR;
};
exports.getLogLevel = getLogLevel;
